import React from 'react';

import PropTypes from 'prop-types';
import UpwardLoadingButton from 'ui/Buttons/LoadingButton';

const SaveButton = (props) => {
   return (
      <UpwardLoadingButton
         type='submit'
         className='btn-dark-orange btn-rounded'
         isLoading={props.isLoading}
         disabled={props.disabled}
         onClick={props.onClick}
      >
         Save
      </UpwardLoadingButton>
   )
};

SaveButton.propTypes = {
   isLoading: PropTypes.bool,
   disabled: PropTypes.bool,
   onClick: PropTypes.func,
};

SaveButton.defaultProps = {
   isLoading: false,
   disabled: false,
   onClick: null,
};

export default SaveButton;
